// Backend-driven public events client (Phase 10D).
// The backend returns ONLY published events from GET /api/events; archived/past
// events are filtered server-side and never exposed here.
import api from '@/services/api';

// GET /api/events — public published catalog + verified-organizer + published DJ
// events, PLUS dynamically expanded DJ recurring-series occurrences.
// The backend now supports a global Upcoming/Past tab (?tab=upcoming|past|all).
// The Events page does its own client-side upcoming/past split, so it requests
// `all` to receive both; pass an explicit tab to filter server-side.
export function fetchEvents(tab = 'all') {
  const t = tab ? `?tab=${encodeURIComponent(tab)}` : '';
  return api.get(`/events${t}`);
}

// GET /api/events/{slug} — public event detail. Throws on 404 (caller handles).
export function fetchEventBySlug(slug) {
  return api.get(`/events/${encodeURIComponent(slug)}`);
}

// GET /api/events/{slug}/similar — Version 1 rule-based Similar Events (public,
// read-only). Returns an array of public EventPublic items (may be empty []).
// limit is capped server-side at 6.
export function fetchSimilarEvents(slug, limit = 6) {
  return api.get(`/events/${encodeURIComponent(slug)}/similar?limit=${encodeURIComponent(limit)}`);
}
